import { BriefingsAboutData } from "content-ui/briefings/fetchers/briefingsAboutFetcher";
import Markdown from "components/markdown/markdown";
import Button from "components/buttonNew/button";
import { useMixpanelTracking } from "../../../../lib/hooks/useMixpanelTracking";
import { useRouter } from "next/router";

type HeaderSectionProps = Pick<
  BriefingsAboutData,
  | "title"
  | "marketingPoints"
  | "marketingPointsHeading"
  | "secondaryButtonLabel"
  | "secondaryButtonUrl"
  | "primaryCtaLabel"
  | "primaryCtaUrl"
>;

const HeaderSection = ({
  title,
  secondaryButtonLabel,
  secondaryButtonUrl,
  primaryCtaUrl,
  primaryCtaLabel,
  marketingPoints,
  marketingPointsHeading,
}: HeaderSectionProps) => {
  const { track } = useMixpanelTracking();
  const router = useRouter();

  const handleTracking = async (
    event: string,
    {
      text,
      url,
    }: {
      text: string;
      url: string;
    }
  ) => {
    await track(event, {
      "Click text": text,
      "Click link": url,
      "Page path": router.asPath,
      Component: "HeaderSection",
    });
  };

  return (
    <div
      className={
        "flex flex-col justify-between gap-[70px] py-[70px] lg:flex-row lg:flex-nowrap lg:gap-[97px]"
      }
    >
      <div className={"flex flex-col"}>
        <h1 className="mb-[30px] font-recklessBold text-[32px] leading-[130%] md:text-[52px] [&_p]:m-0 [&_strong]:text-pro-blue">
          <Markdown text={title} options={{ forceBlock: false }} />
        </h1>
        <div className={"flex flex-row flex-wrap gap-x-[10px] gap-y-[20px]"}>
          {secondaryButtonLabel && secondaryButtonUrl && (
            <Button
              size={"medium"}
              component={"link"}
              colour={"black"}
              href={secondaryButtonUrl}
              className={"ga-briefings-about-cta-secondary"}
              onClick={async () =>
                await handleTracking("Briefings about link click", {
                  text: secondaryButtonLabel,
                  url: secondaryButtonUrl,
                })
              }
            >
              {secondaryButtonLabel}
            </Button>
          )}
          <Button
            size={"medium"}
            component={"link"}
            colour={"navy"}
            href={primaryCtaUrl}
            className={"ga-briefings-about-cta"}
            onClick={async () =>
              await handleTracking("Briefings about link click", {
                text: primaryCtaLabel,
                url: primaryCtaUrl,
              })
            }
          >
            {primaryCtaLabel}
          </Button>
        </div>
      </div>
      {marketingPoints && marketingPoints.length > 0 && (
        <div
          className={
            "flex w-full flex-[0_0_auto] flex-col md:items-center md:justify-center lg:max-w-[500px] lg:justify-center"
          }
        >
          {marketingPointsHeading && (
            <h3
              className={
                "mb-4 text-center font-bold text-[18px] text-mono-40 lg:max-w-[90%]"
              }
            >
              {marketingPointsHeading}
            </h3>
          )}
          <ul className={"flex w-full flex-col gap-4"}>
            {marketingPoints.map((el, index) => {
              return (
                <li
                  key={index}
                  className={
                    "w-full bg-white p-[14px] text-center font-bold text-[16px]"
                  }
                >
                  {el.heading}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default HeaderSection;
